import isClient from './isClient';

const isRunningOnFeatureServer =
  isClient() &&
  window?.location?.hostname === 'consumer.feature.nest.joybird.com';

const isFeatureServer = () => isRunningOnFeatureServer;

export default isFeatureServer;
